module.exports = __webpack_public_path__ + "img/pensando.png.a60d2664.webp";